export default __webpack_public_path__ + "static/media/banner-mobile.20ee2826.png";